import Vue from "vue";
import Vuex from "vuex";
import Account from "./modules/account";
import ActivityLog from "./modules/activityLog";
import Alert from "./modules/alert";
import Bank from "./modules/bank";
import Breadcrumb from "./modules/breadcrumb";
import Comment from "./modules/comment";
import Contact from "./modules/contact";
import Export from "./modules/export";
import FetchData from "./modules/fetchData";
import Finance from "./modules/finance";
import Loading from "./modules/loading";
import LogIn from "./modules/logIn";
import Merchant from "./modules/merchant";
import Notification from "./modules/notification";
import Package from "./modules/package";
import Pnd from "./modules/pnd";
import PP30 from "./modules/pp30";
import PrivateFile from "./modules/privateFile";
import Register from "./modules/register";
import Setting from "./modules/setting";
import Upload from "./modules/upload";
import User from "./modules/user";
import Videofeedback from "./modules/videoFeedback";
import Withholding from "./modules/withholding";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    LogIn,
    Breadcrumb,
    Alert,
    Loading,
    Contact,
    Setting,
    Withholding,
    PP30,
    Pnd,
    Bank,
    Account,
    Comment,
    Notification,
    Export,
    Upload,
    Merchant,
    Register,
    Package,
    User,
    ActivityLog,
    FetchData,
    Videofeedback,
    PrivateFile,
    Finance,
  },
  strict: true,
});

export default store;
